(function ($) {
  "use strict";

  $(document).ready(function () {
    var swiper = new Swiper(".swiper#customSlider", {
      rewind: false,
      slidesPerView: 1,
      observer: true,
      observeParents: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
    });

    // Cambio variante
    $(".swatch :radio").change(function () {
      var optionIndex = $(this).closest(".swatch").attr("data-option-index");
      var optionValue = $(this).val();
      $(this).closest("form").find(".single-option-selector").eq(optionIndex).val(optionValue).trigger("change");
    });
  });
})(jQuery);
